import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { AdmCreateRequestDto } from "@/dto/AdmDto";
import { AdmAuth } from "@/constants/code";

/**
 * 관리자 생성 폼 Hook
 *
 * @returns
 *
 * @author bart <bart@ymjlab.com>
 * @version 1.0
 * @since 2024-12-24
 */
export default function useCreateForm(
  onSubmit: (data: AdmCreateRequestDto) => void
) {
  const methods = useForm({
    resolver: yupResolver<AdmCreateRequestDto>(
      yup.object().shape({
        admId: yup
          .string()
          .min(3, "아이디는 3자 이상이어야 합니다.")
          .required("아이디를 입력해주세요."),
        admNm: yup.string().required("이름을 입력해주세요."),
        pwd: yup
          .string()
          .matches(
            /^(?=.*[a-z])(?=.*\d)(?=.*[!@#$%^&*])[A-Za-z\d!@#$%^&*]{6,}$/,
            "비밀번호는 영문과 숫자, 특수기호 조합하여 6자리 이상 입력하셔야 합니다."
          )
          .required("비밀번호를 입력해주세요."),
        pwdConfirm: yup
          .string()
          .oneOf([yup.ref("pwd")], "비밀번호가 일치하지 않습니다.")
          .matches(
            /^(?=.*[a-z])(?=.*\d)(?=.*[!@#$%^&*])[A-Za-z\d!@#$%^&*]{6,}$/,
            "비밀번호 확인은 영문과 숫자, 특수기호 조합하여 6자리 이상 입력하셔야 합니다."
          )
          .required("비밀번호 확인을 입력해주세요."),
        email: yup
          .string()
          .email("이메일 형식이 올바르지 않습니다.")
          .required("이메일을 입력해주세요."),
        admAuth: yup
          .mixed<AdmAuth>()
          .oneOf(
            Object.values(AdmAuth),
            "관리자 권한과 일치하지 않는 속성입니다."
          )
          .required("관리자 권한을 선택해주세요."),
      })
    ),
  });

  const handleSubmit = async () => {
    const isValid = await methods.trigger();

    if (isValid) {
      const data = methods.getValues();
      onSubmit(data);
    }
  };

  return {
    methods,
    handleSubmit,
  };
}
